import React from 'react';
import NextImage, { StaticImageData } from 'next/image';

import { Card, Heading, Text, ArrowButton, ImageWrapper } from './Publication.styled';
import { LinkButtonProps } from 'Elements/Button';

export interface Props {
    id: string;
    backgroundColourGrey?: boolean;
    header: string;
    image: {
        alt: string;
        src: StaticImageData | string;
    };
    text: string;
    link?: LinkButtonProps;
}

const PublicationCard: React.FC<Props> = props => {
    const { id, backgroundColourGrey, header, image, text, link } = props;

    return (
        <Card id={id} $backgroundColourGrey={backgroundColourGrey}>
            <Heading>{header}</Heading>
            <ImageWrapper>
                <NextImage {...image} fill style={{ objectFit: 'cover' }} />
            </ImageWrapper>
            <Text>{text}</Text>
            {link && <ArrowButton {...link} />}
        </Card>
    );
};

export default PublicationCard;
